<template>
    <div>
        <el-header class="navbg" >
            <div class="contBox">
                <hq-nav></hq-nav>
            </div>
        </el-header>
        <el-main class="mainBg">
            <div class="banner" :style="bannerBg" v-if="this.data.isShow">
                <div class="posi">
                    <p>{{this.data.bgBt}}</p>
                    <el-divider class="fg"></el-divider>
                    <p>{{this.data.bgText}}</p>
                </div>
            </div>
            <div v-else class="noBg">
                <div class="contBox ModuleCont">
                    <el-row>
                        <el-col :span="12">
                            <div class="imgBox">
                                <img :src="require('../assets/images/'+ this.data.moduleImg)" alt="">
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="btBox">
                                <p class="bt">{{ this.data.bgBt }}</p>
                                <h5 class="btText">
                                    <pre>{{this.data.model}}</pre>
                                </h5>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>

            <div  v-if="this.data.isShow">
                <div class="contBox ModuleCont" >
                    <el-divider class="fg center"></el-divider>
                    <h3>{{ this.data.tx.names }}</h3>
                    <ul class="txBox">
                        <li v-for="(d,index) in this.data.tx.child" :key="index">
                            <div class="imgDiv"><img :src="require('../assets/images/'+ d.txImg)" alt=""></div>
                            <h6>{{d.txBt}}</h6>
                            <!--<p v-html="d.txText"></p>-->
                            <pre>{{d.txText}}</pre>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="bgBoxHui1" v-else>
                <div class="contBox ModuleCont elseCont" v-if="this.data.bgText.length != 0">
                    <h3>模块简介<el-divider class="fg"></el-divider></h3>
                    <p class="pText" v-for="(text,index) in this.data.bgText" :key="index">
                        {{ text }}
                    </p>
                </div>
            </div>

            <div class="bgBoxKY paddBox" :class="{'bgBoxCM' : typeBg,'noBg':!this.data.isShow }">
                <div class="contBox ModuleCont">
                    <img class="icon" v-if="this.data.isShow" :src="require('../assets/images/'+ this.data.dataIcon)" alt="">
                    <el-divider class="fg center"></el-divider>

                    <h3  v-if="this.data.isShow">{{ this.data.bgBt }}性能参数表</h3>
                    <h3  v-else>主要技术参数</h3>

                    <h4 v-if="this.data.isShow">
                        <div class="h4Title"><pre>{{ this.data.bgBt }}型号</pre></div>
                        <div style="width: auto;">
                            <div class="h4Cont">
                                <p v-for="(d,index) in  this.data.model" :key="index">
<!--                                    <span v-for="(item,i) in d" :key="i">{{ item }}</span>-->
                                    {{ d }}
                                </p>
                            </div>

                        </div>
                    </h4>
                    <h4 v-else class="noFlex">{{ this.data.bgBt }}型号 <span> {{ this.data.model }}</span></h4>

                    <div class="detail" :class="{'isDes':!this.data.isShow}">
                        <div v-if="this.data.src !== undefined" class="srcBtn">
                            <div class="detailBt">
                                <el-divider class="delBtFg" direction="vertical"></el-divider>
                                {{this.data.src.name}}
                            </div>
                            <el-link class="srcLink" :underline="false" href="#/contactUs">联系我们</el-link>
                        </div>

                        <div v-else>
                            <el-descriptions
                               class="desTions"
                               :column="1"
                               :colon="false"
                               v-for="(d,index) in this.data.data"
                               :key="index"
                            >
                                <template slot="title">
                                    <div class="detailBt"><el-divider class="delBtFg" direction="vertical"></el-divider>{{d.name}}</div>
                                </template>
                                <el-descriptions-item
                                   v-for="(s,index) in d.child"
                                   :key="index"
                                   :label="s.name"
                                   label-class-name="detLab"
                                   content-class-name="detCont"
                                >
                                    <div class="contPre" v-if="Array.isArray(s.data)" :class="{ contPre2 : s.data.length <= 1 }">
                                        <div class="ContData" v-for="(l,i) in s.data" :key="i">
                                            <span v-for="(t,len) in l" :key="len">
                                                {{ t }}
                                            </span>
                                        </div>
                                    </div>
                                    <div style="width: 74rem;" v-else>
                                        {{s.data }}
                                    </div>
                                </el-descriptions-item>
                            </el-descriptions>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bgBoxHui1 paddBox" v-if="this.data.moduleAllImg !== 'NoImg.jpg' && !this.data.isShow ===true">
                <div class="contBox ModuleCont" >
                    <el-divider class="fg center"></el-divider>
                    <h3>模块结构图</h3>
                    <img class="imgAll" :src="require('../assets/images/'+ this.data.moduleAllImg)" alt="">
                </div>
            </div>
        </el-main>
        <el-footer class="footer">
            <hq-footer></hq-footer>
        </el-footer>
    </div>
</template>

<script>
    import Nav from "./Nav";
    import Footer from "./Footer";

    export default {
        name: "ModuleDetail",
        data () {
            return {
                type:"",
                data:{},
                bannerBg:"",
                moduleData:require("../assets/JSON/ModuleDetail.json"),
                typeBg : false
            }
        },
        created() {
            this.type = this.$route.params.type;
            for (let i = 0; i < this.moduleData.length;i++ ){
                if(this.type === this.moduleData[i].name){
                    let dataJson = require("../assets/JSON/"+this.moduleData[i].data);
                    if(this.moduleData[i].isModule){
                        this.data = dataJson[this.moduleData[i].jsonName];
                    }else{
                        this.data = dataJson[this.moduleData[i].name];
                        this.bannerBg = "background: #000000 url('"+ require('../assets/images/'+this.data.bgBanner) + "') no-repeat left top;background-size:100%;";
                    }
                }
            }
        },
        mounted() {
            let type = this.$route.params.type;
            if (type === "CMPro" || type === 'CM') {
                this.typeBg = true;
            }
        },
        components:{
            "hq-nav":Nav,
            "hq-footer":Footer
        }
    }
</script>

<style>
    .fg{
        width: 3.75rem;
        height: 0.25rem;
        background: #e7211a;
        margin: 1.25rem 0;
    }
    .delBtFg{
        width: 0.25rem;
        height: 1.75rem;
        background: #e7211a;
        margin: 0 10px 0 0;
        float: left;
    }
    .center{
        margin: 0 auto;
    }
    .bgBoxBlack{
        padding: 7.1875rem 0;
        background: #000000;
    }
    .bgBoxKY{
        background:#191919 url("../assets/images/KYbg.jpg") no-repeat right top;
    }
    .bgBoxCM{
        background:#191919 url("../assets/images/CMbg.jpg") no-repeat right top;
    }
    .bgBoxHui1{
        background:#191919;
    }
    .noBg{
        background: #000000 !important;
    }
    .imgBox{
        width: 100%;
        height: 30rem;
        padding: 5rem 0;
        overflow: hidden;
    }
    .imgBox img{
        max-width: 100%;
        max-height: 100%;
    }
    .btBox{
        width: 100%;
        height: 30rem;
        overflow: hidden;
        color: #ffffff;
    }
    .btBox .bt{
        width: 100%;
        font-size: 1.75rem;
        margin: 10rem 0 0;
    }
    .btBox .btText{
        width: 100%;
        font-size: 3.25rem;
        margin: 1rem 0 0;
    }
    .btBox .btText pre{
        font-family: AlibabaPuHuiTi-Bold;
        margin: 0;
    }
    .ModuleCont{
        width: 85.5rem;
        height: auto;
        overflow: hidden;
        margin:  0 auto;
    }
    .ModuleCont h3{
        color: #ffffff;
        font-family: AlibabaPuHuiTi-Bold;
        font-size: 2.25rem;
    }
    .elseCont{
        padding: 3rem 0;
    }
    .elseCont h3{
        text-align: left;
    }
    .elseCont .pText{
        font-family: AlibabaPuhuiTiR;
        font-size: 1.25rem;
        color: #ffffff;
        text-align: left;
        line-height: 2.5rem;
    }
    .ModuleCont h4{
        color: #ffffff;
        font-family: AlibabaPuHuiTi-Bold;
        font-size: 1.575rem;
        text-align: left;
        margin-top: 4.0625rem;
        width: 100%;
        height: auto;
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0;
    }
    .ModuleCont h4 .h4Title{
        height: auto;
        width: 8rem;
    }
    .ModuleCont h4 .h4Title pre{
        font-family: AlibabaPuHuiTi-Bold;
        font-size: 1.575rem;
    }
    .ModuleCont h4 .h4Cont{
        height: auto;
        display: flex;
        justify-content: space-around;
        align-items: flex-start;
        flex-direction: row;

    }
    .ModuleCont h4 .h4Cont p{
        width: 11rem;
        margin-top: 0;
        text-align: center;
    }
    .ModuleCont h4 .h4Cont p span{
        display: inline-block;
        width: 100%;
        height: auto;
        text-align: center;
    }
    .ModuleCont h4.noFlex{
        background: #191919;
        display: block;
        padding: 0.5rem;
    }
    .ModuleCont h4.noFlex span{
        margin-left: 5rem;
    }
    .ModuleCont .icon{
        width: 3.625rem;
        height: 3.625rem;
        margin-bottom: 1rem;
    }

    .el-header{
        padding: 0;
        height: auto !important;
    }
    .paddBox{
        padding: 5.1875rem 0;
    }
    .navbg{
        background: url("../assets/images/navbg.jpg") no-repeat top center;
        background-size: 100% 100%;
    }
    .mainBg{
        height: auto;
        margin: 0;
        padding: 0;
    }
    .banner{
        width: 100%;
        height: 56.875rem;
        background: #000000 url("../assets/images/image_3.jpg") no-repeat left top;
        background-size: 100% auto;
        position: relative;
    }
    .posi{
        position: absolute;
        top: 50%;
        left: 50%;
        text-align: left;
        width: 32.125rem;
        height: auto;
        overflow: hidden;
        margin-top: -5.3125rem;
    }
    .banner p:first-child{
        font-family: AlibabaPuHuiTi;
        font-weight: bold;
        font-size: 2.25rem;
        color: #ffffff;
        margin: 0;
    }

    .banner p:last-child{
        font-family: AlibabaPuHuiTi-Light;
        font-size: 1.125rem;
        color: #ffffff;
        line-height: 1.875rem;
    }

    .txBox{
        width: 100%;
        height: auto;
        overflow: hidden;
        padding: 0;
        margin: 6.5625rem 0 3rem 0;
    }
    .txBox li{
        width: 16.875rem;
        height: auto;
        overflow: hidden;
        float: left;
        margin: 0 3rem;
    }
    .txBox li .imgDiv{
        width: 11.25rem;
        height: 8.5rem;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .txBox li h6{
        font-family: AlibabaPuHuiTi-Bold;
        font-size: 1.875rem;
        color: #ffffff;
        margin: 5.375rem auto 1.625rem;
    }
    .txBox li p{
        text-align: center;
        line-height: 2rem;
        font-family: AlibabaPuHuiTi;
        font-size: 1.125rem;
        color: #888888;
    }
    .txBox li pre{
        text-align: center;
        line-height: 2rem;
        font-family: AlibabaPuHuiTi;
        font-size: 1.1rem;
        color: #888888;
        table-layout: fixed;
        white-space:normal;
        word-break:break-all;
    }
    .txBox li:first-child{
        margin-left: 0;
    }
    .txBox li:last-child{
        margin-right: 0;
    }
    .txBox li:nth-child(1) .imgDiv img{
        width: 11.25rem;
        height: 5.5rem;
        margin: 0 auto;
    }
    .txBox li:nth-child(2) .imgDiv img{
        width: 8rem;
        height: 8.125rem;
        margin: 0 auto;
    }
    .txBox li:nth-child(3) .imgDiv img{
        width: 12rem;
        height: 8.5rem;
        margin: 0 auto;
    }
    .txBox li:nth-child(4) .imgDiv img{
        width: 9.2625rem;
        height: 7.875rem;
        margin: 0 auto;
    }

    .desTions{
        background: none;
        margin: 1rem 0 4.375rem;
    }
    .desTions:last-child{
        margin-bottom: 0;
    }
    .detailBt{
        font-family: AlibabaPuHuiTi;
        font-size: 1.5625rem;
        color: #ffffff;
        line-height: 1.5625rem;
        margin: 0;
    }
    .detLab,.detCont{
        background: #000000;
        height: 3.375rem;
        color: #ffffff;
        font-size: 1rem;
        line-height: 2.6rem;
        margin-right: 0 !important;
    }

    .detLab{
        width: 8.5rem;
        height: auto;
        text-align: left;
        padding: 0 10px;
    }
    .detCont{
        width: 100%;
        height: auto;
        text-align: center;
    }
    .isDes .detCont{
        padding-left: 5rem;
        text-align: left;
    }
    .detCont p{
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
        margin: 0;
    }

    .detCont ul{
        width: 4.0625rem;
        height: auto;
        overflow: hidden;
        float: left;
        margin: 1rem 9rem 0;
    }
    .detCont ul li{
        width: 100%;
        height: auto;
        font-size: 1.125rem;
        text-align: center;
        list-style: none;
        line-height: 1.875rem;
    }
    .desTions .el-descriptions__body{
        background: none;
        color: #ffffff;
    }
    .desTions .el-descriptions-item__container{
        width: 100%;
        justify-content: space-between;
    }
    .desTions table tbody:nth-child(even) .detLab,
    .desTions table tbody:nth-child(even) .detCont{
        background:#191919;
    }
    .desTions .el-descriptions__body table td, .el-descriptions__body table th{
        padding-bottom: 0 !important;
        padding: 0 !important;
    }

    .imgAll{
        max-width: 100%;
        height: auto;
    }

    .contPre{
        display: flex;
        justify-content: space-around;
        align-items: flex-start;
        flex-direction: row;
        margin: 0;
        font-family: "Microsoft YaHei";
    }
    .contPre .ContData{
        width: 11rem;
    }
    .contPre .ContData span{
        width: 100%;
        height: auto;
        line-height: 22px;
        white-space: pre;
        text-align: left;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 1rem 0;
    }
    .contPre2{
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: row;
        margin: 0;
        font-family: "Microsoft YaHei";
        width: 74rem;
    }

    .srcBtn{
        width: 100%;
        height: auto;
        overflow: hidden;
        text-align: left;
        margin-top: 2rem;
    }
    .srcBtn .srcLink{
        padding: 10px 20px;
        /*background: #f56c6c;*/
        background: #d5382e;
        margin-top: 1rem;
        color: #ffffff;
    }
    .srcBtn .srcLink:hover{
        color: #ffffff;
        background: #f78989;
    }
</style>
